import {
  GET_ALL_MERCHANT_ROUTES_URL,
  GET_ROUTE_CONFIG_PARAMS_URL,
} from 'constants/url';
import { RouteConfig, RouteConfigList } from 'containers/InsightsAI/types';
import request from 'utils/request';

export const getRouteConfigParams = async (
  routeId: number,
): Promise<RouteConfig> => {
  try {
    const { url, method } = GET_ROUTE_CONFIG_PARAMS_URL;
    const updatedUrl = url.replace('$routeId$', routeId.toString());
    const response = await request(updatedUrl, { method });
    return response;
  } catch (e) {
    return {} as RouteConfig;
  }
};

export const getMerchantRoutes = async (): Promise<RouteConfigList> => {
  try {
    const { url, method } = GET_ALL_MERCHANT_ROUTES_URL;
    const response = await request(url, { method });
    return response;
  } catch (e) {
    return [] as RouteConfigList;
  }
};
